import { useState } from "react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { api, errMsg } from "@/lib/api";

const ADMIN_STATUSES = ["Weaving", "Ready", "Dispatched", "Delivered", "Cancelled"];
const MFR_STATUSES = ["Weaving", "Ready", "Dispatched"];
const sel = "h-10 rounded-md border border-[#D4AF37]/20 bg-[#0B0907] px-3 text-sm";

export function OrderActions({ order, isAdmin, manufacturers, onChange }) {
  const [mid, setMid] = useState("");
  const [status, setStatus] = useState("Weaving");
  const [note, setNote] = useState("");

  const run = async (fn, ok) => {
    try {
      const { data } = await fn();
      toast.success(ok);
      setNote("");
      onChange(data);
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  const post = (s) => run(() => api.post(`/orders/${order.id}/updates`, { status: s, note }), "Update sent");

  if (!isAdmin && order.status === "Assigned")
    return (
      <div className="space-y-3" data-testid="order-respond">
        <Input placeholder="Note for admin (optional)" value={note} onChange={(e) => setNote(e.target.value)} className="bg-[#0B0907] border-[#D4AF37]/20" data-testid="order-note-input" />
        <div className="flex gap-3">
          <button onClick={() => post("Accepted")} className="btn-glow flex-1 rounded-full bg-[#D4AF37] py-2.5 text-xs font-semibold uppercase tracking-[0.15em] text-[#0B0907]" data-testid="accept-order-button">Accept order</button>
          <button onClick={() => post("Declined")} className="flex-1 rounded-full border border-[#E06D3B]/50 py-2.5 text-xs uppercase tracking-[0.15em] text-[#E06D3B]" data-testid="decline-order-button">Decline</button>
        </div>
      </div>
    );

  return (
    <div className="space-y-4">
      {isAdmin && ["Placed", "Declined"].includes(order.status) && (
        <div className="flex gap-2" data-testid="assign-section">
          <select value={mid} onChange={(e) => setMid(e.target.value)} className={`${sel} flex-1`} data-testid="assign-manufacturer-select">
            <option value="">Choose manufacturer…</option>
            {manufacturers.map((m) => <option key={m.id} value={m.id}>{m.name}{m.region ? ` (${m.region})` : ""}</option>)}
          </select>
          <button disabled={!mid} onClick={() => run(() => api.post(`/orders/${order.id}/assign`, { manufacturer_id: mid, note }), "Order assigned")} className="btn-glow rounded-full bg-[#D4AF37] px-5 text-xs font-semibold uppercase tracking-[0.15em] text-[#0B0907] disabled:opacity-40" data-testid="assign-order-button">Assign</button>
        </div>
      )}
      {(isAdmin || order.status !== "Declined") && (
        <div className="flex flex-col sm:flex-row gap-2" data-testid="post-update-section">
          <select value={status} onChange={(e) => setStatus(e.target.value)} className={sel} data-testid="update-status-select">
            {(isAdmin ? ADMIN_STATUSES : MFR_STATUSES).map((s) => <option key={s}>{s}</option>)}
          </select>
          <Input placeholder="Add a note…" value={note} onChange={(e) => setNote(e.target.value)} className="bg-[#0B0907] border-[#D4AF37]/20 flex-1" data-testid="update-note-input" />
          <button onClick={() => post(status)} className="btn-glow rounded-full border border-[#D4AF37]/50 px-5 py-2 text-xs uppercase tracking-[0.15em] text-[#F3E5AB] hover:bg-[#D4AF37] hover:text-[#0B0907]" data-testid="post-update-button">Send update</button>
        </div>
      )}
    </div>
  );
}
